import { ApiCacheTags } from '@qapline/api';
import { config } from 'config';
import { attachmentsApi } from 'core/attachments/api';

import { TAttachmentDeleteRequestBody, TAttachmentDeleteResponseBody } from '../types';

const updateAttachmentApi = attachmentsApi.injectEndpoints({
    endpoints: (builder) => ({
        deleteAttachment: builder.mutation<TAttachmentDeleteResponseBody, TAttachmentDeleteRequestBody>({
            query: ({ attachmentId }) => {
                return {
                    url: config.api.endpoints.attachments.delete.replace(':id', attachmentId.toString()),
                    method: 'DELETE',
                };
            },
            invalidatesTags: (_, __, arg) => [
                { type: ApiCacheTags.attachment.item },
                { type: ApiCacheTags.attachment.file, id: arg.attachmentId },
                { type: ApiCacheTags.attachment.list },
                { type: ApiCacheTags.commission.list },
            ],
        }),
    }),
});

export const { useDeleteAttachmentMutation } = updateAttachmentApi;
